import { isObject } from '../../helpers/is-object';
import { Role } from '../../helpers/permissions';
import { ModerationCommand, ModerationCommandObject } from './types';

export function isOwner(role: Maybe<Role>) {
    return role === Role.OWNER;
}

export function isAdmin(role: Maybe<Role>) {
    return role === Role.ADMIN;
}

/**
 * Определяет, является ли пользователь модератором по его роли
 */
export function isModerator(role: Maybe<Role>): boolean {
    return isOwner(role) || isAdmin(role);
}

export function isModerationCommandObject(value: unknown): value is ModerationCommandObject {
    if (!value || !isObject(value)) {
        return false;
    }

    return (
        'source' in value &&
        'command' in value &&
        isObject(value.command) &&
        'type' in value.command &&
        typeof value.command.type === 'string' &&
        Object.values(ModerationCommand).includes(value.command.type as ModerationCommand)
    );
}
